import React, {Component} from 'react';
import {connect} from 'react-redux';
import {ceil} from 'lodash';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {Modal, Button, Grid, Dropdown, TextArea, Input} from 'semantic-ui-react';
import {dateFormatPicker, noTimeZoneShortISODate} from '../../../../common/constants/datesFormat';
import {getNumericValue} from '../../../../common/util/fieldsValidation';
import {Actions} from '../../../../common/actions';
import './outsourced.scss';

class OutsourcedInfoModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'provider': '',
      'workDays': null,
      'requestDate': '',
      'deliveryDate': '',
      'observation': '',
      'unitPrice': 0,
      'totalPrice': 0,
    };
    this.changeRequestDate = this.changeRequestDate.bind(this);
    this.changeDeliveryDate = this.changeDeliveryDate.bind(this);
    this.onCloseModalClick = this.onCloseModalClick.bind(this);
    this.onSaveClick = this.onSaveClick.bind(this);
    this.handleOnBlurPrice = this.handleOnBlurPrice.bind(this);
  }

  componentDidMount() {
    this.props.fetchProvidersOutsourced();
  }

  componentDidUpdate(prevProps) {
    const {element} = this.props;
    const {unitPrice} = this.state;
    if (!prevProps.element || !element) {
      return;
    }

    if (prevProps.element.unitPrice !== element.unitPrice && element.unitPrice !== unitPrice) {
      this.setState({'unitPrice': ceil(element.unitPrice, 2)});
    }
    
    if (prevProps.element.quantity !== element.quantity && unitPrice) {
      const totalPrice = element.quantity * unitPrice;
      this.setState({'totalPrice': ceil(totalPrice, 2)});
    }
  }

  getValueFormatted(value, field) {
    if (field === 'workDays') {
      return parseInt(value.substring(0, 2), 10);
    }
    if (field === 'unitPrice') {
      let priceValue = value;

      if (/[a-zA-Z]/.test(priceValue)) {
        return null;
      }
      if (priceValue.includes(',')) {
        const decimalValue = priceValue.replace(/,/g, '.');
        priceValue = parseFloat(decimalValue);
      }
      return priceValue > 0 ? priceValue : null;
    }
    return value;
  }

  getProvidersOptions() {
    return this.props.providersList.map((item) => {
      return {'text': item.name, 'value': item.code};
    });
  }

  handleOnBlurPrice(event) {
    const price = event.target.value;
    this.setState({'unitPrice': getNumericValue(price, 2)});
  }

  changeRequestDate(date) {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);

    const {requestDate, deliveryDate} = this.state;
    if (dateFormatted === requestDate) {
      return;
    }

    const newState = {'requestDate': dateFormatted};
    if (moment(date) > moment(deliveryDate)) {
      newState.deliveryDate = dateFormatted;
    }
    this.setState(newState);
  }

  changeDeliveryDate(date) {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);
    if (dateFormatted === this.state.deliveryDate) {
      return;
    }
    this.setState({'deliveryDate': dateFormatted});
  }

  onCloseModalClick(action, data) {
    this.props.onCloseModal(action, data);
  }

  onSaveClick() {
    const {provider, observation, workDays, requestDate, deliveryDate, unitPrice} = this.state;
    const priceValue = isNaN(Number(unitPrice)) ? unitPrice.replace(/[^0-9.-]+/g, '') : unitPrice;
    const outsourcedData = {provider, observation, workDays, requestDate, deliveryDate,
      'unitPrice': parseFloat(priceValue),
    };
    this.onCloseModalClick('save', outsourcedData);
  }

  onChangeValues(value, field) {
    const valueFormatted = this.getValueFormatted(value, field);
    const newState = {};
    newState[field] = valueFormatted;

    if (field === 'unitPrice') {
      const {element} = this.props;
      const price = valueFormatted ? ceil(valueFormatted, 2) : null;
      const totalPrice = element.quantity * price;
      newState.totalPrice = ceil(totalPrice, 2);
    }
    this.setState(newState);
  }

  render() {
    const {loadingProviders, modalWasOpen} = this.props;
    const {provider, observation, workDays, requestDate, deliveryDate, unitPrice} = this.state;

    return (
      <Modal size='large' open={modalWasOpen} className='outsourced-modal'>
        <Modal.Header>Datos del subcontrato</Modal.Header>

        <Modal.Content>
          <Modal.Description>
            <div className='title-bar'>
              <div className='filters-section'>
                <Grid textAlign='left'>
                  <Grid.Row>
                    <Grid.Column width={4}>
                      <h4>Proveedor:</h4>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Dropdown
                        value={provider}
                        options={this.getProvidersOptions()}
                        selection
                        search
                        loading={loadingProviders}
                        disabled={loadingProviders}
                        noResultsMessage='Proveedor no encontrado'
                        onChange={(e, {value}) =>
                          this.onChangeValues(value, 'provider')
                        }
                      />
                    </Grid.Column>
                    <Grid.Column width={2}>
                      <h4>Días Trabajo:</h4>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Input
                        type='number'
                        min='1'
                        step='1'
                        placeholder='Días Trabajo'
                        value={workDays}
                        onChange={(e, {value}) =>
                          this.onChangeValues(value, 'workDays')
                        }
                      />
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row>
                    <Grid.Column width={4}>
                      <h4>Fecha Solicitud:</h4>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <DatePicker
                        customInput={<Input icon='calendar' size='small' />}
                        dateFormat={dateFormatPicker}
                        selected={
                          requestDate ?
                            moment(
                              requestDate,
                              noTimeZoneShortISODate
                            ).toDate() :
                            null
                        }
                        onChange={this.changeRequestDate}
                        locale='es'
                        placeholderText='Fecha Solicitud'
                      />
                    </Grid.Column>
                    <Grid.Column width={2}>
                      <h4>Fecha Entrega:</h4>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <DatePicker
                        customInput={<Input icon='calendar' size='small' />}
                        dateFormat={dateFormatPicker}
                        selected={
                          deliveryDate ?
                            moment(
                              deliveryDate,
                              noTimeZoneShortISODate
                            ).toDate() :
                            null
                        }
                        onChange={this.changeDeliveryDate}
                        minDate={moment(requestDate).toDate()}
                        placeholderText='Fecha Entrega'
                        disabled={!requestDate}
                        locale='es'
                      />
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row>
                    <Grid.Column width={4}>
                      <h4>Precio Unitario:</h4>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Input
                        label={{'basic': true, 'content': '$'}}
                        labelPosition='left'
                        type='text'
                        placeholder='Precio'
                        value={unitPrice || 0}
                        onChange={(e, {value}) =>
                          this.onChangeValues(value, 'unitPrice')
                        }
                        onBlur={this.handleOnBlurPrice}
                      />
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row>
                    <Grid.Column width={4}>
                      <h4>Observaciones:</h4>
                    </Grid.Column>
                    <Grid.Column width={10}>
                      <TextArea
                        maxLength='200'
                        rows='4'
                        value={observation}
                        onChange={(e, {value}) =>
                          this.onChangeValues(value, 'observation')
                        }
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </div>
            </div>
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={() => this.onCloseModalClick('close', {})}>
            Cancelar
          </Button>
          <Button
            positive
            disabled={
              !provider ||
              !workDays ||
              !requestDate ||
              !deliveryDate ||
              !unitPrice ||
              !observation
            }
            onClick={this.onSaveClick}
          >
            Guardar
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingProviders': state.tasksAssignmentInQualityAssuranceOrders.loadingProvidersOutsourced,
    'providersList': state.tasksAssignmentInQualityAssuranceOrders.providersOutsourcedList,
  };
};

const {
  fetchProvidersOutsourced,
} = Actions;

export default connect(mapStateToProps, {
  fetchProvidersOutsourced,
})(OutsourcedInfoModal);
